/**
 * Shared picker thresholds — parity with kraahl-mobile `components/ui/native-picker.tsx`
 * (`ENUM_MENU_MAX_ITEMS`) and `SearchablePickerSheet` (20+ rows).
 *
 * PWA mapping:
 * - ≤ {@link ENUM_MENU_MAX_ITEMS}: Radix `Select` / `DropdownMenu` (mobile: `NativeMenu`)
 * - ≥ {@link SEARCHABLE_THRESHOLD}: `SearchableDropdown` + `DockSheet` (mobile: `SearchablePickerSheet`)
 * - Dynamic taxonomy: always `SearchableDropdown` + server search (`onSearchQueryChange`)
 */

export const ENUM_MENU_MAX_ITEMS = 8;

/** @deprecated Use {@link ENUM_MENU_MAX_ITEMS} */
export const ENUM_ACTION_SHEET_MAX_ITEMS = ENUM_MENU_MAX_ITEMS;

export const SEARCHABLE_THRESHOLD = 20;

/** @deprecated Use {@link SEARCHABLE_THRESHOLD} */
export const VIRTUALIZE_THRESHOLD = SEARCHABLE_THRESHOLD;

export function shouldUseClassicPicker(itemCount: number): boolean {
  return itemCount > 0 && itemCount <= ENUM_MENU_MAX_ITEMS;
}

export function shouldUseSearchablePicker(itemCount: number): boolean {
  return itemCount >= SEARCHABLE_THRESHOLD;
}
